export default "__VITE_ASSET__Dc0$5d6F__"